(ns storrito.app.message
  (:require [storrito.state.core :as state]
            [cljs.core.async :as a]
            )
  (:require-macros [cljs.core.async.macros :refer [go]]))

;; Concept:

;; Provides a way to inform the user about global app events, for
;; example after an entity has been successfully transacted to the
;; server.

(defn message-panel
  [app-state]
  (when-let [app-message (:app/message @app-state)]
    (let [type (:type app-message)
          text-color (get {:info "text-blue-900"
                           :success "text-green-900"
                           :danger "text-red-900"
                           :warning "text-yellow-900"}
                          type
                          "text-gray-900")
          bg-color (get {:info "bg-blue-200"
                         :success "bg-green-200"
                         :danger "bg-red-200"
                         :warning "bg-yellow-200"}
                        type
                        "bg-white")]
      [:div.flex.items-center.justify-center.w-full.fixed.top-20.p-2
       {:style {:pointer-events "none"
                ;; over the modal panel `storrito.modal.core`:
                :z-index "100000"}}
       [:div.rounded.shadow-lg.relative.py-3.px-5
        {:style {:pointer-events "all"}
         :class bg-color}
        [:span.font-bold
         {:class text-color}
         (:content app-message)]
        [:button.absolute.top-1.right-1
         {:class text-color
          :aria-label "delete"
          :onClick (fn [e]
                     (.preventDefault e)
                     (swap! app-state
                            dissoc :app/message))}
         [:i.fas.fa-times.opacity-80]]]])))

(defn set-message!
  "Sets the current :app/message to the given `app-message`."
  [app-message]
  (swap! state/state assoc :app/message app-message))

(def default-duration-ms
  ;; the default duration how long the app message box is shown
  5000)

(def message-timeout
  (atom nil))

(defn show-message!
  "Sets the current :app/message to the given `app-message` and hides
   it after `(:duration app-message default-duration-ms)`."
  [app-message]
  (set-message! app-message)
  (when @message-timeout
    (js/clearTimeout @message-timeout))
  (let [timeout (js/setTimeout (fn []
                                 (swap! state/state (fn [state-value]
                                                      ;; only hide app-message if it is still the
                                                      ;; same message:
                                                      (if (= (:app/message state-value)
                                                             app-message)
                                                        (dissoc state-value :app/message)
                                                        state-value)))
                                 (js/clearTimeout @message-timeout))
                               (:duration app-message
                                 default-duration-ms))]
    (reset! message-timeout
            timeout)))

(defn hide-message!
  []
  (swap! state/state
         dissoc :app/message))
